import React from "react";

import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <div className={styles.Footer}>
      <img className={styles.Image} src="image/logo.png" alt="logo" />
      <div className={styles.TextContainer}>
        <div>
          회사명 :
          바론테크&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;사업자등록번호
          : 508-10-65976
        </div>
        <div>
          전화번호 :
          062-571-0401&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;팩스
          :
          0504-428-1411&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          E-mail : varontech@naver.com
          <br />
          주소 : 광주광역시 북구 용봉로 77, 전남대학교 산학협력 2호관 211호
        </div>
        <div>Copyright © 2022 바론테크. All rights reserved.</div>
      </div>
    </div>
  );
}
